<script lang="ts">
  import { getContext } from "svelte";
  import { ConnectMapApp, type RouteNode as R } from "../app";
  import RouteNode from "./RouteNode.svelte";
  import BtnControl from "../BtnControl.svelte";
  import Icon from "../Icon.svelte";
  import BtnGroupControl, { type ToggleOption } from "../BtnGroupControl.svelte";

  const app = getContext<ConnectMapApp<any>>('app');
  
  const { 
    src_poi,
    dst_poi,
    is_mobile,
    T,
  } = app;

  $: can_route = $src_poi && $dst_poi;

  const options: ToggleOption[] = [
    { label: $T`route_option_shortest`, value: 'shortest' },
    { label: $T`route_option_accessible`, value: 'accessible' },
  ]

  function changeRouteOption (event: CustomEvent<ToggleOption>) {
    app.setRouteOption(event.detail.value);
  }
  
</script>

<div class="route-setup">
  <div class="waypoints">
    <RouteNode poi={$src_poi}>
      <strong slot="title">{$T`route_node_src`}</strong>
      <svelte:fragment slot="hint">
        {$T`route_node_src_hint`}
        {#if $is_mobile}
          <BtnControl on:click={app.state.showMap} rounding={50} width="auto" height="24px">
            {$T`route_node_src_showmap`}
          </BtnControl>
        {/if}
      </svelte:fragment>
    </RouteNode>
    <RouteNode poi={$dst_poi}>
      <strong slot="title">{$T`route_node_dst`}</strong>
      <svelte:fragment slot="hint">
        {$T`route_node_dst_hint`}
      </svelte:fragment>
    </RouteNode>
  </div>

  <hr />

  <div class="controls">
    <BtnGroupControl {options} on:change={changeRouteOption} />

    <BtnControl on:click={app.state.flip} chromeless>
      <Icon name="flip" />
    </BtnControl>
  </div>
  
  <BtnControl on:click={app.state.showRoute} disabled={!can_route} width="full">
    {$T`route_show`}
  </BtnControl>
</div>

<style>
  .route-setup {
    padding: var(--_p2);
  }

  .waypoints {
    font-size: 14px;
  }

  .controls {
    display: flex;
    margin-bottom: 1rem;
    justify-content: space-between;
    align-items: center;
  }
</style>